export default __webpack_public_path__ + "static/media/team-2.6c230fb7.jpg";